<template>
	<div class="profile">
		<section class="d-flex flex-column">
			<header class="masthead mb-auto">
				<HomeNav />
			</header>
		</section>
		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8">
						<div class="card custom-card">
							<div class="card-body">
								<h2 class="text-center mt-3">Who is watching?</h2>
								<div class="row my-5  justify-content-center">
									<div class="col-md-3 ">
										<a href="homepage.html">
											<img
												src="../../assets/img/smiley.png"
												alt=""
												width="32"
											/>
											Noel
										</a>
									</div>
									<div class="col-md-3 ">
										<a href="#">
											<img
												src="../../assets/img/plus-green.svg"
												alt=""
												width="32"
											/>
											Add Profile
										</a>
									</div>
								</div>
								<div class="row  justify-content-center">
									<div class="col-md-12 text-center">
										<a href="manage-profiles-1.html" class="btn btn-primary">
											Manage Profiles
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";

export default {
	name: "Profile",
	components: {
		HomeNav,
	},
	data() {
		return {
			data: null,
		};
	},
	mounted() {
		window.scroll(0, 0);
	},
	created() {
		this.$store.commit("showPopup", false);
		if (this.$store.state.user.logedin == false) {
			this.$store.commit("setLoader", false);
			this.$router.push("/login");
			return false;
		}
		this.data = this.$store.state.user;
		this.$store.commit("showdefaultFooter", true);
	},
	methods: {
		gotoUpdatePassword() {
			this.$router.push("/updatepassword");
		},
		logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/login");
				}
			});
		},
	},
	computed: {
		subscription() {
			const subscriptions = this.$store.state.user.userInfo.subscriptions;
			let subscriptionString = "";

			subscriptions.forEach((el) => {
				subscriptionString += `${el.package}   ( ${el.sub} )\n`;
			});
			return subscriptionString;
		},
		email() {
			return this.$store.state.user.userInfo.profile.username;
		},
		fullname() {
			return (
				this.$store.state.user.userInfo.name[0].toUpperCase() +
				this.$store.state.user.userInfo.name.slice(1)
			);
		},
		address() {
			var profile = this.$store.state.user.userInfo.profile;
			return (
				profile.address +
				", " +
				profile.city +
				", " +
				profile.state +
				", " +
				profile.country +
				""
			);
		},
		phone() {
			return this.$store.state.user.userInfo.profile.telephone;
		},
	},
};
</script>

<style></style>
